import * as yup from 'yup';

export const transferValidator = yup.object().shape({
  contactId: yup.string().required('ra.validation.required').nullable(),
  hunterId: yup.string().required('ra.validation.required').nullable(),
  id: yup.string().required(),
  organizationId: yup.string().required('ra.validation.required').nullable(),
});
